import { Drawer, Divider, List, ListItem, Box, Typography, Button, Avatar, Badge } from '@mui/material';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import { MdOutlineStarOutline, MdOutlineInsertChartOutlined, MdOutlineAccountBox, MdOutlineCameraAlt, MdOutlineAccountBalanceWallet, MdOutlineSupportAgent, MdOutlineSettings, MdOutlineInfo, MdExitToApp, MdOutlineCircle, MdCircle } from 'react-icons/md';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import GroupsIcon from '@mui/icons-material/Groups';
import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { IMenu } from '../../interfaces/menu';
import { groupMenuItemsBySection } from '../../utils/menuUtils';
import baranLogo from '../../assets/baran-logo.png';
import { useTranslation } from 'react-i18next';
import { UserContext } from '../../contexts/UserContext';
import { getInitials } from '../../utils/string';
import { useSidebar } from '../../contexts/SidebarContext';
import SidebarItem from './SidebarItem';
import { KeyboardReturnRounded, ViewStreamOutlined } from '@mui/icons-material';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';

const Menu = () => {
	const { t } = useTranslation();

	const [activeItem, setActiveItem] = useState(t('dashboard'));
	const [activeSubItem, setActiveSubItem] = useState('');
	const { sidebarVarient, sidebarOpen, sidebarPin, setSidebarOpen, setSidebarPin } = useSidebar();

	const { user } = useContext(UserContext);

	const isAdmin = user?.is_admin;

	const adminMenuItems: (IMenu | undefined | boolean)[] = [
		{
			itemTitle: 'dashboard',
			sectionTitle: 'dashboard',
			icon: <HomeOutlinedIcon className="size-6 text-text-secondary" />,
			route: '/dashboard',
			hideArrow: true,
		},
		{
			itemTitle: 'users',
			sectionTitle: 'manage_users',
			icon: <GroupsIcon className="size-6 text-text-secondary" />,
			hideArrow: false,
			subMenuItems: [
				{
					title: 'users_list',
					route: '/admin/user',
				},
				{
					title: 'admin_list',
					route: '/admin/admin',
				},
				{
					title: 'create_new_admin',
					route: '/admin/admins/new',
				},
				{
					title: 'ad_giver_users',
					route: '/admin/ad_giver',
				},
				{
					title: 'ad_receiver_users',
					route: '/admin/ad_reciever',
				},
				{
					title: 'marketer_users',
					route: '/admin/marketers',
				},
			],
		},
		{
			itemTitle: 'roles',
			sectionTitle: 'manage_users',
			icon: <GroupsIcon className="size-6 text-text-secondary" />,
			hideArrow: false,
			subMenuItems: [
				{
					title: 'roles_list',
					route: '/admin/role',
				},
			],
		},
		{
			itemTitle: 'ad_tariff',
			sectionTitle: 'ad_platforms',
			icon: <GroupsIcon className="size-6 text-text-secondary" />,
			hideArrow: false,
			subMenuItems: [
				{
					title: 'category',
					route: '/tariff/category',
				},
				{
					title: 'influencers_list',
					route: '/tariff/influencers',
				},
				{
					title: 'telegram_groups_list',
					route: '/tariff/telegram-groups',
				},
				{
					title: 'instagram_pages_list',
					route: '/tariff/instagram-pages',
				},
				{
					title: 'bale_pages_list',
					route: '/tariff/bale-chanels',
				},
				{
					title: 'grow_social_list',
					route: '/tariff/social-growth',
				},
				{
					title: 'eita_groups_list',
					route: '/tariff/eita-groups',
				},
				{
					title: 'rubika_groups_list',
					route: '/tariff/rubika-groups',
				},
				{
					title: 'websites_list',
					route: '/tariff/websites',
				},
			],
		},
		{
			itemTitle: 'campaigns',
			sectionTitle: 'manage-campaign',
			icon: <MdOutlineStarOutline className="size-6 text-text-secondary" />,
			hideArrow: false,
			subMenuItems: [
				{
					title: 'campaign_category',
					route: '/campaigns/category',
				},
				{
					title: 'campaigns_list',
					route: '/campaigns/list',
				},
				{
					title: 'active_campaigns',
					route: '/campaigns/active',
				},
				{
					title: 'payment_pending_campaigns',
					route: '/campaigns/pending',
				},
				{
					title: 'completed_campaigns',
					route: '/campaigns/completed',
				},
				// {
				// 	title: 'unsetteled_campaigns',
				// 	route: '/campaigns/unsettled',
				// },
				{
					title: 'recommend_hour',
					route: '/campaigns/recommend_hour',
				},
				{
					title: 'medias',
					route: '/campaigns/medias',
				},
				{
					title: 'chanels_packages',
					route: '/campaigns/chanels',
				},
			],
		},
		{
			itemTitle: 'finance',
			sectionTitle: 'finance_management',
			icon: <MdOutlineAccountBalanceWallet className="size-6 text-text-secondary" />,
			hideArrow: false,
			subMenuItems: [
				{
					title: 'add-balance',
					route: '/finance/add-balance',
				},
				{
					title: 'transactions',
					route: '/finance/payments',
				},
				// checkout may use later
				// {
				// 	title: 'checkout',
				// 	route: '/finance/	checkout',
				// },
				{
					title: 'ongoingcampaigns',
					route: '/finance/payment/ongoingcampaigns',
				},
				{
					title: 'campaignslist',
					route: '/finance/payment/campaignslist',
				},
				{
					title: 'campaigns_price_and_view',
					route: '/finance/media/view_campaign',
				},
				{
					title: 'mediaـgrowthـcampaigns',
					route: '/finance/media/required_add',
				},
			],
		},
		{
			itemTitle: 'studio',
			sectionTitle: 'studio',
			icon: <MdOutlineCameraAlt className="size-6 text-text-secondary" />,
			hideArrow: false,
			subMenuItems: [
				{
					title: 'category_management',
					route: '/admin/studio/category/manage',
				},
				{
					title: 'content_management',
					route: '/admin/studio/content',
				},
				{
					title: 'quality_management',
					route: '/admin/studio/qualit',
				},
				{
					title: 'package_list',
					route: '/admin/studio/package',
				},
				{
					title: 'new_request',
					route: '/studio',
				},
				{
					title: 'request_management',
					route: '/admin/studio/management',
				},
				{
					title: 'current_requested',
					route: '/admin/studio/requested',
				},

				{
					title: 'paid_requests',
					route: '/admin/studio/paid',
				},

				{
					title: 'studio_page_design',
					route: '/admin/studio/design',
				},
			],
		},
		{
			itemTitle: 'ticket',
			sectionTitle: 'tickets_management',
			icon: <MdOutlineCameraAlt className="size-6 text-text-secondary" />,
			hideArrow: false,
			subMenuItems: [
				{
					title: 'tickets_list',
					route: '/admin/tickets/list',
				},

				{
					title: 'active_tickets_list',
					route: '/admin/tickets/active/list',
				},
			],
		},
		{
			itemTitle: 'blog_sidebar',
			sectionTitle: 'blog_list_sidebar',
			icon: <NotificationsNoneOutlinedIcon className="size-6 text-text-secondary" />,
			hideArrow: false,
			subMenuItems: [
				{
					title: 'category_blog',
					route: 'admin/blog/create',
				},
				{
					title: 'blog_list_sidebar',
					route: 'admin/blog',
				},
			],
		},
		{
			itemTitle: 'settings',
			sectionTitle: 'settings',
			icon: <MdOutlineSettings className="size-6 text-text-secondary" />,
			hideArrow: false,
			subMenuItems: [
				{
					title: 'user-account',
					route: '/settings/user-account',
				},
				{
					title: 'site-setting',
					route: 'admin/settings/site-setting',
				},
			],
		},
		{
			itemTitle: 'block',
			sectionTitle: 'block',
			icon: <ViewStreamOutlined className="size-6 text-text-secondary" />,
			hideArrow: false,
			subMenuItems: [
				{
					title: 'block_list',
					route: '/block/list',
				},
			],
		},
		{
			itemTitle: 'retur_to_landing',
			sectionTitle: 'retur_to_landing',
			icon: <KeyboardReturnRounded className="size-6 text-text-secondary" />,
			route: 'https://maino.ir/',
			hideArrow: true,
		},
		{
			itemTitle: 'exit',
			sectionTitle: 'logout-from-account',
			icon: <MdExitToApp className="size-6 text-text-secondary" />,
			route: '/',
			hideArrow: true,
		},
	];

	const userMenuItems: (IMenu | undefined | boolean)[] = [
		{
			itemTitle: 'dashboard',
			sectionTitle: 'dashboard',
			icon: <HomeOutlinedIcon className="size-6 text-text-secondary" />,
			route: '/dashboard',
			hideArrow: true,
		},
		{
			itemTitle: 'cart',
			sectionTitle: 'cart',
			icon: <ShoppingCartOutlinedIcon className="size-6 text-text-secondary" />,
			route: '/finance/cart',
			hideArrow: true,
		},
		{
			itemTitle: 'campaigns',
			sectionTitle: 'manage-campaign',
			icon: <MdOutlineStarOutline className="size-6 text-text-secondary" />,
			hideArrow: false,
			subMenuItems: [
				{
					title: 'create_campaign',
					route: '/campaigns/create',
				},
				{
					title: 'manage-campaign',
					route: '/campaigns',
				},
				{
					title: 'ordered-ad',
					route: '/campaigns/ordered-ad',
				},
			],
		},
		{
			itemTitle: 'my-social-media',
			sectionTitle: 'manage-campaign',
			icon: <MdOutlineInsertChartOutlined className="size-6 text-text-secondary" />,
			hideArrow: false,
			subMenuItems: [
				{
					title: 'ad_list',
					route: '/my-social-media/list-of-my-pages',
				},
				{
					title: 'register_new_page',
					route: '/my-social-media/new',
				},
			],
		},
		{
			itemTitle: 'my-tasks',
			sectionTitle: 'manage-campaign',
			icon: <MdOutlineAccountBox className="size-6 text-text-secondary" />,
			hideArrow: false,
			subMenuItems: [
				{
					title: 'pending-ads',
					route: '/my-tasks/pending/ads',
				},
				{
					title: 'published-ads',
					route: '/my-tasks/published-ads',
				},
				{
					title: 'received-ad',
					route: '/my-tasks/received-ad',
				},
			],
		},
		{
			itemTitle: 'studio',
			sectionTitle: 'studio',
			icon: <MdOutlineCameraAlt className="size-6 text-text-secondary" />,
			hideArrow: false,
			subMenuItems: [
				{
					title: 'previous-orders',
					route: '/studio/previous-orders',
				},
				{
					title: 'order_new_request',
					route: '/studio',
				},
			],
		},
		{
			itemTitle: 'finance',
			sectionTitle: 'finance',
			icon: <MdOutlineAccountBalanceWallet className="size-6 text-text-secondary" />,
			hideArrow: false,
			subMenuItems: [
				{
					title: 'add_balance',
					route: '/finance/add-balance',
				},
				{
					title: 'financial-reports',
					route: '/finance/reports',
				},
				{
					title: 'invoices',
					route: '/finance/invoices',
				},
				{
					title: 'payments',
					route: '/finance/payments',
				},
				{
					title: 'settlement',
					route: '/finance/settlement',
				},
			],
		},
		{
			itemTitle: 'support',
			sectionTitle: 'support',
			icon: <MdOutlineSupportAgent className="size-6 text-text-secondary" />,
			hideArrow: false,
			subMenuItems: [
				{
					title: 'send-new-ticket',
					route: '/support/new-ticket',
				},
				{
					title: 'tickets-list',
					route: '/support/tickets-list',
				},
			],
		},
		{
			itemTitle: 'settings',
			sectionTitle: 'settings',
			icon: <MdOutlineSettings className="size-6 text-text-secondary" />,
			hideArrow: false,
			subMenuItems: [
				{
					title: 'user-account',
					route: '/settings/user-account',
				},
				// {
				// 	title: 'my-companies',
				// 	route: '/settings/my-companies',
				// },
			],
		},
		{
			itemTitle: 'help',
			sectionTitle: 'help',
			icon: <MdOutlineInfo className="size-6 text-text-secondary" />,
			route: '/help',
			hideArrow: true,
		},
		{
			itemTitle: 'retur_to_landing',
			sectionTitle: 'retur_to_landing',
			icon: <KeyboardReturnRounded className="size-6 text-text-secondary" />,
			route: 'https://maino.ir/',
			hideArrow: true,
		},
		{
			itemTitle: 'exit',
			sectionTitle: 'logout-from-account',
			icon: <MdExitToApp className="size-6 text-text-secondary" />,
			route: '/',
			hideArrow: true,
		},
	];

	const menuItems = isAdmin ? adminMenuItems : userMenuItems;

	const validMenuItems = menuItems.filter((item): item is IMenu => item !== undefined && typeof item !== 'boolean');

	const menuSections: string[] = Array.from(new Set(validMenuItems.map(item => item.sectionTitle)));

	const groupedItems = groupMenuItemsBySection(validMenuItems);

	const handlePinMenu = () => {
		const newState = !sidebarPin;
		setSidebarPin(newState);
		if (newState) {
			localStorage.removeItem('sidebarOpen');
		} else {
			localStorage.setItem('sidebarOpen', 'false');
		}
	};

	const handleEnterMenu = () => {
		if (sidebarPin) return;
		setSidebarOpen(true);
	};

	const handleLeaveMenu = () => {
		if (sidebarPin) return;
		setSidebarOpen(false);
	};

	const handleSubItemSelect = (subItemTitle: string, parentTitle: string) => {
		setActiveItem(parentTitle);
		setActiveSubItem(subItemTitle);
	};

	const drawerWidth = sidebarVarient === 'temporary' || sidebarOpen ? 'w-64' : 'w-16';

	const handleClose = () => {
		setSidebarOpen(false);
	};

	return (
		<Drawer className={`delay-50 z-50 transition-all duration-500 ${drawerWidth} fixed bottom-0 start-0 top-0`} variant={sidebarVarient} open={sidebarOpen} onMouseOver={handleEnterMenu} onMouseOut={handleLeaveMenu} onClose={handleClose}>
			<Box className={`delay-50 overflow-hidden overflow-y-auto px-3 transition-all duration-500 ${drawerWidth}`}>
				<div className="mb-7 flex items-center justify-between pt-5">
					<Link to={'/'}>
						<img src={baranLogo} alt="logo" className="cursor-pointer" />
					</Link>
					{sidebarOpen && (sidebarPin ? <MdCircle className="cursor-pointer text-text-secondary" onClick={handlePinMenu} /> : <MdOutlineCircle className="cursor-pointer text-text-secondary" onClick={handlePinMenu} />)}
				</div>
				{sidebarOpen && (
					<>
						{!isAdmin ? (
							<>
								<Box className={'min-h-2 rounded-lg bg-primary-focus p-3'}>
									<div className="relative flex items-center">
										<Badge
											color="success"
											variant="dot"
											overlap="circular"
											sx={{
												'& .MuiBadge-dot': {
													borderRadius: 9999,
													border: '2px solid white',
													padding: '4px',
												},
											}}
											anchorOrigin={{ vertical: 'bottom', horizontal: t('dir') === 'rtl' ? 'right' : 'left' }}
										>
											<Avatar alt="avatar" src={String(user?.image) as string} className="ml-2 h-10 w-10">
												{getInitials(user?.name!)}
											</Avatar>
										</Badge>
										{user?.name.trim() ? (
											<Typography className="text-sm text-text-secondary">{user?.name}</Typography>
										) : (
											<Button variant="text" component={Link} to="/settings/user-account">
												{t('complete_profile')}
											</Button>
										)}
									</div>
								</Box>
								<Button sx={{ boxShadow: 2 }} className="mt-3 h-14 w-full text-2xl" component={Link} to="/campaigns/create">
									+ {t('create_campaign')}
								</Button>
							</>
						) : (
							<Box className="flex h-24 items-center justify-center rounded-lg bg-primary-main shadow-admin-avatar-bg-shadow">
								<Avatar alt="avatar" src={String(user?.image) as string} className="ml-6 h-16 w-16">
									{getInitials(user?.name!)}
								</Avatar>
								{user?.name ? (
									<Box className="gap flex flex-col gap-2">
										<Typography className="text-base text-white">{user?.name}</Typography>
										<Typography className="text-sm text-white">{t('site_admin')}</Typography>
									</Box>
								) : (
									<Button variant="text" component={Link} to="/settings/user-account">
										{t('complete_profile')}
									</Button>
								)}
							</Box>
						)}
					</>
				)}

				<List>
					{menuSections.map((section, sectionIndex) => (
						<React.Fragment key={sectionIndex}>
							<ListItem>{section !== 'dashboard' && sidebarOpen && <Typography className="text-text-disabled">{t(section)}</Typography>}</ListItem>
							<SidebarItem items={groupedItems[section] || []} activeItem={activeItem} activeSubItem={activeSubItem} handleSubItemSelect={handleSubItemSelect} />
							{sectionIndex < menuSections.length - 1 && <Divider />}
						</React.Fragment>
					))}
				</List>
				<Divider />
			</Box>
		</Drawer>
	);
};

export default Menu;
